import { render } from "./CaiDatDSDichVu.vue?vue&type=template&id=2d3c1f2b&scoped=true&ts=true"
import script from "./CaiDatDSDichVu.vue?vue&type=script&lang=ts"
export * from "./CaiDatDSDichVu.vue?vue&type=script&lang=ts"

import "./CaiDatDSDichVu.vue?vue&type=style&index=0&id=2d3c1f2b&scoped=true&lang=scss"
import "./CaiDatDSDichVu.vue?vue&type=style&index=1&id=2d3c1f2b&lang=scss"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/PHCN/ChiaGioThucHien/VLTL_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3c1f2b"]])

export default __exports__